// ReportHeaderPlanner Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Dropdown from '../../../common/form/dropdown/dropdown.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class ReportHeaderPlanner extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null
    }

    const currDate = DateUtil.getUTCCurrentDate()
    const year = DateUtil.getLocalYear()
    const weekNo = DateUtil.getLocalWeekNo(currDate)

    this.data = {
      year: props.year || year,
      filterType: props.filterType || 'half-year',
      startWeekNo: props.startWeekNo || weekNo - 2,
      startMonth: props.startMonth || 0,
      startDate: props.startDate || new Date()
    }
  }

  static get propTypes () {
    return {
      filterType: PropTypes.string,
      filterTypes: PropTypes.array,
      onChangeFilterType: PropTypes.func,
      onNavigate: PropTypes.func,
      year: PropTypes.number,
      startWeekNo: PropTypes.number,
      startMonth: PropTypes.number,
      onChangeFilter: PropTypes.func,
      employeeProductivity: PropTypes.bool,
      startDate: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      filterType: '',
      filterTypes: [],
      onChangeFilterType: null,
      onNavigate: null,
      year: 0,
      startWeekNo: 0,
      startMonth: 0,
      onChangeFilter: null,
      employeeProductivity: false,
      startDate: null
    }
  }

  render () {
    return (
      <div className='report-header-planner'>
        <div className='colleft'>
          <div className='yearrow'>
            {this._renderMonthInfo()}
            <div className='yearcontrols'>
              <IconButton
                className='action headeraction'
                size='normal'
                type='normal'
                icon='planner-toolbar-previous'
                canHover={false}
                onClick={this._onNavigate.bind(this, false)}
              />
              <IconButton
                className='action actionnext'
                size='normal'
                type='normal'
                icon='planner-toolbar-next'
                canHover={false}
                onClick={this._onNavigate.bind(this, true)}
              />
            </div>
          </div>
        </div>
        <div className='colright'>
          <Dropdown
            source={this.props.filterTypes}
            name='filterType'
            label='report.header.choosePlanner'
            className='gridsort-dropdown repheaderplanner-dropdown'
            value={this.data.filterType}
            onChange={this._onChangeFilterType.bind(this)}
          />
        </div>
        {this._renderFilter()}
      </div>
    )
  }

  /* Private function */
  _addDaysToDate (date, incrDays) {
    const newDate = new Date(date)
    newDate.setDate(date.getDate() + incrDays)

    return newDate
  }

  /* Event handler */
  _onChangeFilterType (value) {
    this.data.filterType = value
    this.forceUpdate()

    this._onChangeFilter()
  }

  _renderFilter () {
    if (this.props.employeeProductivity) {
      return null
    }

    const { year, startMonth, startWeekNo, startDate } = this.data
    const filterItems = []
    if (this._isFilterMonth()) {
      for (let i = 0; i < 6; i++) {
        filterItems.push({
          label: DateUtil.getDisplayMonthByNumber((startMonth + i) % 12)
        })
      }
    } else {
      const lastWeekNo = this._getLastWeekNoOfYear(year)
      for (let i = 0; i < 4; i++) {
        let newWeekNo = startWeekNo + i
        if (newWeekNo > lastWeekNo) {
          newWeekNo = newWeekNo % lastWeekNo
        }

        filterItems.push({
          label: `${IntlUtil.convertMessage(
            'report.header.weekLabel'
          )} ${newWeekNo}`
        })
      }
    }

    return (
      <div className='filter'>
        <div className='filtprev'>
          <IconButton
            className='action actionprev'
            size='normal'
            type='transparent'
            icon='planner-dayprevious'
            canHover
            onClick={this._onNavigate.bind(this, false)}
          />
        </div>
        <div className='filtnext'>
          <IconButton
            className='action actionnext'
            size='normal'
            type='transparent'
            icon='planner-daynext'
            canHover
            onClick={this._onNavigate.bind(this, true)}
          />
        </div>
        <div className='planphasecont'>
          <div
            className={`filterheader${
              this._isFilterMonth() ? '' : ' filterheader-week'
            }`}
          >
            <div className='cont'>
              {filterItems.map((filterItem, idx) => {
                return (
                  <div key={idx} className='filteritem'>
                    <span className='label'>{filterItem.label}</span>
                  </div>
                )
              })}
            </div>
            {!this._isFilterMonth() && !this.props.employeeProductivity ? (
              <div className='days'>
                {_.range(7 * 4).map((dayIdx) => {
                  const day = DateUtil.addDaysToDate(
                    startDate,
                    dayIdx
                  ).getDay()
                  return (
                    <span
                      key={dayIdx}
                      className={
                        day === 0 || day === 6 ? 'item item_weekend' : 'item'
                      }
                    >
                      {DateUtil.addDaysToDate(startDate, dayIdx).getDate()}
                    </span>
                  )
                })}
              </div>
            ) : (
              <div className='days' />
            )}
            {!this._isFilterMonth() && !this.props.employeeProductivity && (
              <div className='lineswrap'>
                {_.range(0, 5).map((idx) => (
                  <div
                    key={idx}
                    className={`lineitem item_${idx}`}
                    style={{ left: `${idx * 25}%` }}
                  />
                ))}
                {_.range(7 * 4).map((idx) => {
                  const day = DateUtil.addDaysToDate(startDate, idx).getDay()
                  const left = day === 0 ? 3.57 : 7.14
                  let perc = 25
                  if (idx > 6 && idx < 14) {
                    perc = 50
                  } else if (idx > 13 && idx < 21) {
                    perc = 75
                  } else if (idx > 20 && idx < 28) {
                    perc = 100
                  }
                  if (day === 0 || day === 6) {
                    return (
                      <div
                        key={idx}
                        className={`weekenditem weekenditem_${idx}`}
                        style={{ left: `${perc - left}%` }}
                      />
                    )
                  }

                  return null
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onNavigate (bNext, _ev) {
    const { year, startMonth, startWeekNo } = this.data
    if (this._isFilterMonth()) {
      if (bNext) {
        this.data.year += startMonth === 11 ? 1 : 0
        this.data.startMonth = startMonth === 11 ? 0 : startMonth + 1
      } else {
        this.data.year -= startMonth === 0 ? 1 : 0
        this.data.startMonth = startMonth === 0 ? 11 : startMonth - 1
      }
    } else {
      const newWeekNo = bNext ? startWeekNo + 1 : startWeekNo - 1
      if (newWeekNo < 1) {
        this.data.year--
        this.data.startWeekNo = DateUtil.getDisplayWeek(
          new Date(year - 1, 11, 31)
        )
      } else if (newWeekNo >= DateUtil.getDisplayWeek(new Date(year, 11, 31))) {
        // If last week of year
        this.data.year++
        this.data.startWeekNo = 1
      } else {
        this.data.startWeekNo = newWeekNo
      }
    }

    this._onChangeFilter()
    this.forceUpdate()
  }

  /* Private functions */
  _renderMonthInfo () {
    const { year, startMonth, startWeekNo } = this.data
    const lastWeekNo = this._getLastWeekNoOfYear(year)

    return (
      <div className='currentyear'>
        <h1 className='title'>
          <IntlMessage ident='report.header.yearTitle' /> {year}
        </h1>
        {this._isFilterMonth() ? (
          <span className='info'>
            <IntlMessage ident='report.header.labelFrom' />
            {` ${DateUtil.getDisplayFullMonthByNumber(startMonth)}`}
            <IntlMessage ident='report.header.labelTo' />
            {` ${DateUtil.getDisplayFullMonthByNumber((startMonth + 5) % 12)}`}
          </span>
        ) : (
          <span className='info'>
            <IntlMessage ident='report.header.labelFrom' />
            {` Week ${startWeekNo}`}
            <IntlMessage ident='report.header.labelTo' />
            {` Week ${
              startWeekNo + 3 === lastWeekNo
                ? lastWeekNo
                : (startWeekNo + 3) % lastWeekNo
            }`}
          </span>
        )}
      </div>
    )
  }

  _isFilterMonth () {
    return this.data.filterType === 'half-year'
  }

  _onChangeFilter () {
    if (this.props.onChangeFilter) {
      const { year, startMonth, startWeekNo } = this.data
      let fromDate = new Date(year, startMonth, 1)
      let toDate = new Date(year, startMonth + 6, 0) // 6 months
      toDate.setHours(23, 59, 59, 0)
      if (!this._isFilterMonth()) {
        fromDate = this._getMondayByWeek(year, startWeekNo)
        toDate = DateUtil.addDaysToDate(fromDate, 7 * 4) // 6 weeks
      }

      const filterPlanner = {
        filterType: this.data.filterType,
        fromDate: fromDate,
        toDate: toDate,
        year: year,
        startMonth: startMonth,
        startWeekNo: startWeekNo
      }

      this.data.startDate = fromDate

      this.props.onChangeFilter(filterPlanner)
    }
  }

  _getMondayByWeek (year, weekNo) {
    const date = new Date(year, 0, 1 + (weekNo - 1) * 7)
    const day = date.getDay()
    if (day === 1) {
      // If monday
      return date
    }

    const currDate = date.getDate()

    let diff = currDate
    if (day >= 4) {
      diff = currDate - day + (day === 0 ? -6 : 1)
    } else {
      diff = currDate + (1 - day)
    }

    return new Date(date.setDate(diff))
  }

  _getLastWeekNoOfYear (year) {
    const lastDateOfYear = new Date(year, 11, 31)
    let lastWeekNo = DateUtil.getDisplayWeek(lastDateOfYear)

    // If not having 53 weeks
    if (lastDateOfYear.getDay() < 4) {
      lastWeekNo = lastWeekNo - 1
    }

    return lastWeekNo
  }
}

export default ReportHeaderPlanner
